import { POSTGRES_CODES } from "@lib/errors/postgresCodes";
import type { FeatureErrorMapper } from "@lib/errors/types";

export const productErrorMapper: FeatureErrorMapper = (action, err) => {
  if (
    action === "delete" &&
    err.code === POSTGRES_CODES.FOREIGN_KEY_VIOLATION
  ) {
    return "Cannot delete this product — remove its inventory records first.";
  }

  if (err.code === POSTGRES_CODES.UNIQUE_VIOLATION) {
    if (err.constraint?.includes("name") || err.message.includes("name")) {
      return "A product with this name already exists.";
    }
    if (err.constraint?.includes("sku") || err.message.includes("sku")) {
      return "A product with this SKU already exists.";
    }
    return "A product with these details already exists.";
  }

  if (err.code === POSTGRES_CODES.NOT_NULL_VIOLATION) {
    return "A required product field is missing.";
  }

  return null;
};
